import { IConnector } from "@unifiprotocol/core-sdk";
import { atom } from "recoil";

export const Connector = atom<IConnector | undefined>({
  key: "connector",
  default: undefined,
  dangerouslyAllowMutability: true,
});
